import { getDialCodeItemFromList } from '@/components/shared/components/NewContextForms/PhoneFormDoubleField/utils/getDialCodeItemFromList';

export const DefaultDialCodeOption = getDialCodeItemFromList('+34') ?? {
  dialCode: '34',
  name: 'Spain (España)',
  iso2: 'ES',
};
